import { GET, POST, PUT, DELETE } from './api'

const table = "quizzes"

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
}

export const ReadQuiz = async () => {
  return await GET(`/${table}?populate=*`, true);
}

export const ReadQuizTime = async (id) => {
  return await GET(`/quiz-temp/time/${id}`, true);
}

export const ReadOneQuiz = async (id) => {
  return await GET(`/${table}/${id}`, true);
}

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
}

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
}
